/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Bundleid2Inputs */

const en__field_bundleid2 = /** @type {(inputs: _Field_Bundleid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`bundle id`)
};

const de__field_bundleid2 = /** @type {(inputs: _Field_Bundleid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bundle ID`)
};

/**
* | output |
* | --- |
* | "bundle id" |
*
* @param {_Field_Bundleid2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_bundleid2 = /** @type {((inputs?: _Field_Bundleid2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Bundleid2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_bundleid2(inputs)
	return de__field_bundleid2(inputs)
});
export { _field_bundleid2 as "_field_bundleID" }